import { useEffect, useState } from "react";

interface UseScrollSpyOptions {
  sectionIds: string[];
  offset?: number;
}

export function useScrollSpy({ sectionIds, offset = 0 }: UseScrollSpyOptions) {
  const [activeSection, setActiveSection] = useState<string>("");

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      // Find the section that's currently in view
      for (let i = sectionIds.length - 1; i >= 0; i--) {
        const sectionId = sectionIds[i];
        const element = document.getElementById(sectionId);

        if (element) {
          const rect = element.getBoundingClientRect();
          const elementTop = rect.top + window.scrollY;

          // If we've scrolled past the top of this section, it's active
          if (scrollPosition >= elementTop + offset) {
            setActiveSection(sectionId);
            break;
          }
        }
      }
    };

    handleScroll();

    // Add scroll listener to the main page wrapper (parent of all sections)
    document
      .querySelector("#main-page-wrapper")
      ?.addEventListener("scroll", handleScroll);

    return () => {
      // remove scroll listener
      document
        .querySelector("#main-page-wrapper")
        ?.removeEventListener("scroll", handleScroll);
    };
  }, [sectionIds, offset]);

  return activeSection;
}
